<!--
 * @Author: zhaoliang
 * @Date: 2024-05-21 15:07:12
 * @LastEditTime: 2025-10-10 17:25:46
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/views/Membership/component/TripsDetail/index.vue
 *
-->
<template>
  <div class="trips-detail-container">
    <h2 class="global-title">
      <div class="title-box">
        <img src="~img/Shape.png" alt="icon-back" @click="goBack" />
        <span>{{ $t('back') }}</span>
      </div>
      <div class="print-box">
        <img
          v-if="isUpcoming"
          class="print-icon"
          src="~img/icon-print.png"
          alt="icon-back"
          @click="printPDF"
        />
        <span v-if="isUpcoming">{{ $t('tripsdetail-print') }}</span>
        <!-- <img class="faq-icon" src="~img/icon-help.svg" alt="" @click="$router.push('/faqs')" /> -->
        <div class="help-wrapper" @click="showHelpFaq = !showHelpFaq" role="help">
          <span class="icon-help" :class="{ 'icon-help-close': showHelpFaq }"></span>
        </div>
        <template v-if="showHelpFaq">
          <div class="help-box" :style="{ maxHeight: minHeight }">
            <h2><span class="icon-help-reverse"></span> {{ $t('tips-title') }}</h2>
            <template v-for="item in faqlist">
              <h3>{{ item.title }}</h3>
              <p>{{ item.content }}</p>
            </template>
          </div>
        </template>
      </div>
    </h2>
    <div class="trips-detail-content">
      <div class="detail-left">
        <img src="~img/icon-dp-logo.svg" alt="dp-logo" />
        <p v-if="isUpcoming" class="desc">{{ $t('tripsdetail-desc') }}</p>
        <div id="qr-code" v-if="isUpcoming"></div>
        <p class="cancelled" v-if="isCancelled">
          {{ $t('tripsdetail-booking-cancelled') }}
        </p>
        <p class="booking-id">{{ $t('tripsdetail-bookingid') }}: {{ orderInfo.orderNo }}</p>
        <p class="username fs-mask">{{ orderInfo.firstName }} {{ orderInfo.lastName }}</p>
        <p class="dpid" v-if="isUpcoming">{{ orderInfo.bookingDpId }}</p>
        <p class="email fs-mask">{{ orderInfo.email }}</p>
      </div>
      <div class="detail-right">
        <p class="title">{{ orderInfo.loungeName }}</p>
        <p class="desc">
          {{ orderInfo.airport }}{{ orderInfo.iataCode && ` ${orderInfo.iataCode}`
          }}{{ orderInfo.terminal && `, ${orderInfo.terminal}` }}
        </p>
        <div class="info-list">
          <div class="info-item">
            <img src="~img/icon-calendar.svg" alt="" />
            <p class="info-desc">{{ orderInfo.serviceDate }}</p>
          </div>
          <div class="info-item">
            <img src="~img/icon-people.svg" alt="" />
            <p class="info-desc">
              {{ orderInfo.numOfPassengers }} {{ $t('tripsdetail-visitors') }}
            </p>
          </div>
          <div class="info-item">
            <img src="~img/icon-time-solid.svg" alt="" />
            <p class="info-desc">{{ orderInfo.serviceTime }}</p>
          </div>
        </div>
        <div class="info-location">
          {{ orderInfo.location ? `${orderInfo.location} ` : ''
          }}{{
            orderInfo.boardinggate ? `${$t('near-boarding-gate')}: ${orderInfo.boardinggate}` : ''
          }}
        </div>
        <div class="info-payment">
          <div class="step2-entitlements" v-if="entitlementApplied">
            <div class="step2-entitlements-title">
              <img src="~img/icon-entitlement-solid.svg" alt="icon-entitlement" />
              <p>{{ $t('prebook-step2-entitlements') }}</p>
            </div>
            <div class="step2-entitlements-desc">{{ entitlementApplied }}</div>
          </div>
          <div class="step2-topay">
            <div class="step2-topay-title">
              <img src="~img/icon-card-outline.svg" alt="icon-card" />
              <p>{{ $t('prebook-step2-paid') }}</p>
            </div>
            <div class="step2-topay-desc" v-for="(item, index) in paymentList" :key="index">
              <p class="step2-topay-payinfo">{{ item.label }}</p>
              <p class="step2-topay-total">
                {{ orderInfo.payDetail.currencyType }}{{ item.amount }}
              </p>
              <div class="step2-topay-dotted"></div>
            </div>
          </div>
          <div class="step2-divide"></div>
          <div class="step2-total-topay">
            <p>{{ $t('prebook-step2-total-topay', [orderInfo.payDetail.currencyLabel]) }}</p>
            <p>{{ orderInfo.payDetail.currencyType }}{{ orderInfo.payDetail.actualAmount }}</p>
          </div>
          <div class="step2-card-info">
            <div class="step2-card-info-desc">
              <img src="~img/icon-pay-securely.svg" alt="" />
              <p>{{ $t('prebook-step2-card-info-desc') }}</p>
            </div>
            <div class="step2-card-info-cardnum">
              <img src="~img/icon-visa.svg" alt="" />
              <p>**** **** **** {{ orderInfo.last4 }}</p>
            </div>
          </div>
          <!-- <p class="booking-date">{{ $t('tripsdetail-booked') }} {{ orderInfo.bookingDate }}</p> -->
          <p class="booking-date">{{ orderInfo.payTime }}</p>
          <p class="booking-tips">{{ $t('tripsdetail-booking-confirm') }}</p>
          <div
            class="step2-button"
            v-if="isUpcoming && orderInfo.cancelable"
            @click="cancelBooking"
          >
            <button role="button" class="pay-btn">{{ $t('tripsdetail-cancel-btn') }}</button>
          </div>
          <p class="booking-cancel-tips" v-if="isUpcoming">
            <!-- {{ $t('tripsdetail-booking-cancel-tips') }} -->
            {{ orderInfo.notes[1] || '' }}
          </p>
          <p class="cancel-date" v-if="isCancelled">
            {{ orderInfo.cancelTime }}
          </p>
          <p class="cancel-tips" v-if="isCancelled">
            {{ $t('tripsdetail-cancel-confirm') }}
          </p>
        </div>
      </div>
    </div>
    <!-- PDF视图弹窗 -->
    <PDFModal v-model:open="showPdfModal" :pdfUrl="pdfUrl"></PDFModal>
  </div>
</template>
<script>
  import QRCode from 'qrcodejs2';
  import PDFModal from './PDFModal.vue';
  import { mapMutations, mapState } from 'vuex';
  export default {
    name: 'TripsDetail',
    props: {
      minHeight: {
        type: String,
        default: '0px',
      },
    },
    data() {
      return {
        orderInfo: {
          payDetail: {},
        },
        showPdfModal: false,
        pdfUrl: new Blob(),
        showHelpFaq: false,
        faqlist: [],
      };
    },
    mounted() {
      this.getTripsDetail();
      this.getFaqs();
    },
    methods: {
      ...mapMutations(['showMessageModal']),
      getTripsDetail() {
        this.$http.account
          .getTripsDetail({
            lang: this.$i18n.locale,
            orderNo: this.$route.query.orderNo,
            userId: this.userInfo.userId,
            sessionId: this.userInfo.sessionId,
          })
          .then(res => {
            if (res.state === '11') {
              this.orderInfo = res.payload || {};
              this.$nextTick(() => {
                if (this.orderInfo.orderStatus === '1') {
                  this.drawQRCode();
                }
              });
            } else {
              this.showMessageModal({
                key: res.note,
                i18nNeed: false,
              });
              this.orderInfo = {};
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      goBack() {
        this.$router.push({
          path: '/account/mytrips',
        });
      },
      drawQRCode() {
        // 生成二维码
        new QRCode('qr-code', {
          width: 126,
          height: 126,
          text: this.orderInfo.bookingDpId,
          colorDark: '#000',
          colorLight: '#fff',
        });
      },
      cancelBooking() {
        // 取消订单
        this.$http.account
          .cancelBooking({
            orderNo: this.$route.query.orderNo,
            lang: this.$i18n.locale,
            userId: this.userInfo.userId,
            sessionId: this.userInfo.sessionId,
          })
          .then(res => {
            if (res.state === '11') {
              this.getTripsDetail();
            } else {
              this.showMessageModal({
                key: res.note,
                i18nNeed: false,
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      printPDF() {
        this.$http.member
          .getMemberShipPdf({ userId: this.userInfo.userId, sessionId: this.userInfo.sessionId })
          .then(res => {
            this.pdfUrl = res;
            this.showPdfModal = true;
          })
          .catch(err => {
            console.error(err);
          });
      },
      getFaqs() {
        this.$http.account
          .getHelpIcon({
            type: 4,
            lang: localStorage.getItem('lang'),
            userId: this.userInfo.userId,
            sessionId: this.userInfo.sessionId,
          })
          .then(res => {
            if (res.state === '11') {
              this.faqlist = res.payload?.contents || [];
            }
          });
      },
    },
    computed: {
      ...mapState(['userInfo']),
      isUpcoming() {
        return this.orderInfo.orderStatus === '1';
      },
      isPast() {
        return this.orderInfo.orderStatus === '2';
      },
      isCancelled() {
        return this.orderInfo.orderStatus === '3';
      },
      paymentList() {
        // 不展示type1,2  type7等于1,2之和
        return (
          this.orderInfo.payDetail?.payments?.filter(
            item => item.type !== '1' && item.type !== '2' && item.type !== '7',
          ) || []
        );
      },
      entitlementApplied() {
        return this.orderInfo.payDetail?.payments?.find(item => item.type === '7')?.label;
      },
    },
    watch: {},
    filters: {},
    components: { PDFModal },
    directives: {},
  };
</script>
<style lang="scss" scoped>
  .trips-detail-container {
    @include global-title();
    .global-title {
      margin-bottom: 32px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .title-box {
        display: flex;
        align-items: center;
        img {
          width: 15px;
          height: 25px;
          margin-right: 32px;
          cursor: pointer;
        }
      }

      .print-box {
        display: flex;
        align-items: center;
        .print-icon {
          width: 20px;
          height: 20px;
          margin-right: 15px;
          cursor: pointer;
        }
        span {
          @include font(20px, 600);
        }
        // .faq-icon {
        //   width: 40px;
        //   height: 40px;
        //   cursor: pointer;
        //   margin-left: 15px;
        // }

        .help-wrapper {
          margin-left: 15px;
          cursor: pointer;
          z-index: 25;

          .icon-help {
            display: block;
            width: 40px;
            height: 40px;
            background: url('~img/icon-help.svg') no-repeat center;
            background-size: 40px 40px;
            border-radius: 20px;

            &.icon-help-close {
              background: url('~img/icon-help-close-web.svg') no-repeat center;
              background-size: 40px 40px;
              border-radius: 20px;
            }
          }
        }
        .help-box {
          overflow-y: scroll;
          scrollbar-width: none;
          // max-height: 100vh;
          position: absolute;
          width: 500px;
          top: 20px;
          right: 20px;
          z-index: 20;
          padding: 20px 24px;
          color: #fff;
          text-align: left;
          background: #163049;
          border-radius: 8px;
          @include font($size: 20px, $weight: 400);
          &::-webkit-scrollbar {
            display: none;
          }

          .icon-help-reverse {
            display: block;
            width: 30px;
            height: 30px;
            background: url('~img/icon-help-reverse.svg') no-repeat center;
            background-size: 30px 30px;
          }

          h2,
          h3,
          p {
            margin-bottom: 15px;
            line-height: 1.5;
            display: flex;
            align-items: center;
            justify-content: flex-start;

            span {
              margin-right: 5px;
            }
          }
        }
      }
    }
    .trips-detail-content {
      display: flex;

      .detail-left {
        width: 460px;
        min-height: 800px;
        background-color: #f0f3f6;
        margin-right: 50px;
        box-sizing: border-box;
        padding: 80px 60px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        img {
          width: 145px;
          height: 22px;
          margin-bottom: 20px;
        }

        .desc {
          @include font(16px, 600);
          line-height: 20px;
          margin-bottom: 10px;
        }

        #qr-code {
          padding: 15px;
          background-color: #fff;
        }

        .cancelled {
          @include font(20px, 700);
          color: #cc2222;
          margin-top: 20px;
        }

        .booking-id {
          @include font(20px, 600);
          margin-top: 20px;
          margin-bottom: 30px;
          text-align: center;
        }

        .username {
          @include font(28px, 700);
          margin-bottom: 10px;
        }

        .dpid {
          @include font(30px, 600);
          margin-bottom: 10px;
        }

        .email {
          @include font(20px, 400);
        }
      }
      .detail-right {
        flex: 1;
        padding-top: 20px;

        .title {
          @include font(26px, 700);
          margin-bottom: 8px;
        }

        .desc {
          @include font(18px, 400);
          margin-bottom: 25px;
        }

        .info-list {
          display: flex;
          flex-wrap: wrap;
          margin-bottom: 20px;

          .info-item {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            width: 34%;
            margin-bottom: 15px;

            img {
              width: 20px;
              height: 20px;
              margin-right: 10px;
            }

            .info-desc {
              @include font(20px, 400);
            }
          }
        }

        .info-location {
          @include font(18px, 400);
          line-height: 24px;
        }

        .info-payment {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin: 30px 0;

          .step2-entitlements {
            width: 100%;
            display: flex;
            flex-direction: column;
            margin-bottom: 30px;
            .step2-entitlements-title {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              margin-bottom: 10px;

              img {
                width: 26px;
                height: 26px;
                margin-right: 10px;
              }

              p {
                @include font($size: 22px, $weight: 600);
              }
            }
            .step2-entitlements-desc {
              @include font($size: 20px, $weight: 400);
            }
          }

          .step2-topay {
            width: 100%;
            display: flex;
            flex-direction: column;
            margin-bottom: 10px;

            .step2-topay-title {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              margin-bottom: 10px;

              img {
                width: 26px;
                height: 26px;
                margin-right: 10px;
              }

              p {
                @include font($size: 22px, $weight: 600);
              }
            }
            .step2-topay-desc {
              @include font($size: 20px, $weight: 400);
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 10px;
              position: relative;

              p {
                background-color: #ffffff;
                z-index: 10;
              }

              .step2-topay-dotted {
                position: absolute;
                width: 95%;
                border: 1px dotted #b1bdc4;
                bottom: 1px;
              }
            }
          }

          .step2-divide {
            width: 100%;
            border: 1px solid #bec7cc;
            bottom: 1px;
          }

          .step2-total-topay {
            width: 100%;
            margin-top: 10px;
            @include font($size: 22px, $weight: 700);
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .step2-card-info {
            width: 100%;
            margin-top: 30px;
            margin-bottom: 20px;

            .step2-card-info-desc {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              margin-bottom: 10px;

              img {
                width: 18px;
                height: 20px;
                margin-right: 5px;
              }

              p {
                @include font($size: 20px, $weight: 600);
              }
            }

            .step2-card-info-cardnum {
              display: flex;
              justify-content: flex-start;
              align-items: center;

              img {
                width: 38px;
                height: 24px;
                margin-right: 10px;
              }

              p {
                @include font($size: 19px, $weight: 600);
              }
            }
          }
          .cancel-date,
          .booking-date {
            width: 100%;
            @include font(16px, 400);
            line-height: 20px;
            margin-bottom: 5px;
          }
          .booking-tips,
          .cancel-tips {
            width: 100%;
            @include font(16px, 400);
            line-height: 20px;
            margin-bottom: 20px;
          }
          .cancel-date,
          .cancel-tips {
            color: #cc2222;
          }
          .booking-cancel-tips {
            @include font(14px, 400);
            margin-top: 20px;
          }

          .step2-button {
            width: 100%;
            margin-top: 10px;

            .pay-btn {
              cursor: pointer;
              width: 100%;
              height: 64px;
              background-color: #c29d5c;
              color: #ffffff;
              @include font($size: 22px, $weight: 700);
              border-radius: 5px;
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 1024px) {
    .trips-detail-container {
      .global-title {
        @include font(18px, 600);
        line-height: 40px;
        margin-bottom: 12px;
        padding: 0;

        .title-box {
          img {
            width: 12px;
            height: 20px;
            margin-right: 18px;
          }
        }

        .print-box {
          .print-icon {
            width: 16px;
            height: 16px;
            margin-right: 10px;
          }
          span {
            @include font(16px, 600);
          }
          // .faq-icon {
          //   width: 30px;
          //   height: 30px;
          //   cursor: pointer;
          // }
          .help-wrapper {
            .icon-help {
              width: 30px;
              height: 30px;
              background-size: 30px 30px;

              &.icon-help-close {
                background-size: 30px 30px;
              }
            }
          }
          .help-box {
            top: 15px;
            right: 15px;
            width: 300px;
            padding: 16px 20px;
            @include font($size: 12px, $weight: 400);

            .icon-help-reverse {
              width: 20px;
              height: 20px;
              background-size: 20px 20px;
            }

            h2,
            h3,
            p {
              margin-bottom: 10px;
              line-height: 16px;
            }
          }
        }
      }

      .trips-detail-content {
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .detail-left {
          width: 100%;
          padding: 40px 20px;
          min-height: unset;
          margin-right: 0px;

          img {
            width: 150px;
            height: 24px;
            margin-bottom: 15px;
          }

          .desc {
            @include font(14px, 600);
            line-height: 16px;
            margin-bottom: 10px;
          }

          #qr-code {
            padding: 10px;
          }

          .cancelled {
            @include font(14px, 700);
            margin-top: 15px;
          }

          .booking-id {
            @include font(14px, 600);
            margin-top: 10px;
            margin-bottom: 15px;
          }

          .username {
            @include font(20px, 700);
            margin-bottom: 10px;
          }

          .dpid {
            @include font(18px, 600);
            margin-bottom: 10px;
          }

          .email {
            @include font(14px, 400);
          }
        }

        .detail-right {
          width: 100%;
          padding-top: 20px;

          .title {
            @include font(16px, 700);
            margin-bottom: 8px;
          }

          .desc {
            @include font(14px, 400);
            margin-bottom: 20px;
          }

          .info-list {
            margin-bottom: 5px;

            .info-item {
              width: 45%;
              margin-bottom: 10px;

              img {
                width: 15px;
                height: 15px;
                margin-right: 10px;
              }

              .info-desc {
                @include font(14px, 400);
              }
            }
          }

          .info-location {
            @include font(14px, 400);
            line-height: 20px;
          }

          .info-payment {
            margin: 20px 0;

            .step2-entitlements {
              margin-bottom: 15px;

              .step2-entitlements-title {
                margin-bottom: 5px;

                img {
                  width: 20px;
                  height: 20px;
                  margin-right: 10px;
                }

                p {
                  @include font($size: 16px, $weight: 600);
                }
              }
              .step2-entitlements-desc {
                @include font($size: 14px, $weight: 400);
              }
            }

            .step2-topay {
              margin-bottom: 10px;

              .step2-topay-title {
                margin-bottom: 5px;

                img {
                  width: 20px;
                  height: 20px;
                  margin-right: 10px;
                }

                p {
                  @include font($size: 16px, $weight: 600);
                }
              }
              .step2-topay-desc {
                @include font($size: 14px, $weight: 400);
              }
            }

            .step2-divide {
              width: 100%;
              border: 1px solid #bec7cc;
              bottom: 1px;
            }

            .step2-total-topay {
              @include font($size: 16px, $weight: 700);
            }

            .step2-card-info {
              width: 100%;
              margin-top: 30px;
              margin-bottom: 20px;

              .step2-card-info-desc {
                margin-bottom: 10px;

                img {
                  width: 15px;
                  height: 18px;
                  margin-right: 5px;
                }

                p {
                  @include font($size: 16px, $weight: 600);
                }
              }

              .step2-card-info-cardnum {
                img {
                  width: 30px;
                  height: 18px;
                  margin-right: 10px;
                }

                p {
                  @include font($size: 14px, $weight: 400);
                }
              }
            }

            .cancel-date,
            .booking-date {
              @include font(14px, 400);
            }

            .booking-tips,
            .cancel-tips {
              @include font(14px, 600);
              margin-bottom: 10px;
            }

            .cancel-date,
            .cancel-tips {
              color: #cc2222;
            }

            .booking-cancel-tips {
              @include font(14px, 400);
              margin-top: 15px;
            }

            .step2-button {
              .pay-btn {
                height: 48px;
                @include font($size: 16px, $weight: 700);
              }
            }
          }
        }
      }
    }
  }
</style>
